import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import RuleModal from "./RuleModal";
import { getRules } from "../../http/ruleApi";
import { useNavigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../../utils/constants";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";

const RuleChooser = observer(({ rule, setRule }) => {
  const [rules, setRules] = React.useState([]);
  const [platform, setPlatform] = React.useState({});
  const [openChange, setOpenChange] = React.useState(false);
  const [openNew, setOpenNew] = React.useState(false);
  const navigate = useNavigate();
  const { user } = React.useContext(Context);

  const handleChange = (event) => {
    const found = rules.find((x) => {
      return x.id === event.target.value
    });
    setRule(found);
  };
  const platformChange = (event) => {
    setPlatform(event.target.value);
  };

  const handleChangeModalOpen = () => {
    setOpenNew(false);
    setOpenChange(!openChange);
  };
  const handleNewModalOpen = () => {
    setOpenChange(false);
    setOpenNew(!openNew);
  };

  React.useEffect(() => {
    const getData = async () => {
      try {
        const rows = await getRules();
        setRules(rows);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          user.setIsAuth(false);
          return navigate(LOGIN_ROUTE);
        }
      }
    };
    getData();
  }, [openChange, openNew]);

  let platforms = {};
  for (const ruleItem of rules) {
    platforms[ruleItem.provider] = ruleItem.provider;
  }
  platforms = Object.keys(platforms);

  return (
    <Box
      sx={{
        minWidth: 500,
        maxWidth: 500,
      }}
    >
      <Stack direction="row" spacing={5}>
        <FormControl disabled={rules.length < 1} required fullWidth>
          <InputLabel id="demo-simple-select-label1">Платформа</InputLabel>
          <Select
            labelId="demo-simple-select-label1"
            id="demo-simple-select1"
            value={platform}
            label="Платформа"
            color="secondary"
            onChange={platformChange}
          >
            {platforms &&
              platforms.map((name) => {
                return (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
        <FormControl disabled={rules.length < 1} required fullWidth>
          <InputLabel id="demo-simple-select-label">Правило</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={rule ? rule.id : ""}
            label="Правило"
            color="secondary"
            onChange={handleChange}
          >
            {rules &&
                rules.map(({ rule, id, provider }) => {
                return (provider === platform ?
                  <MenuItem key={id} value={id}>
                    {rule.name}
                  </MenuItem> : null
                );
              })}
          </Select>
        </FormControl>
        <Button
          color="secondary"
          disabled={!rule}
          onClick={handleChangeModalOpen}
        >
          Изменить
        </Button>
        <Button color="secondary" onClick={handleNewModalOpen}>
          Добавить
        </Button>
      </Stack>
      {openChange && (
        <RuleModal
          open={openChange}
          setOpen={setOpenChange}
          rule={rule}
          setRule={setRule}
          setRules={setRules}
          rules={rules}
        />
      )}
      {openNew && (
        <RuleModal
          open={openNew}
          setOpen={setOpenNew}
          setRule={setRule}
          setRules={setRules}
          rules={rules}
        />
      )}
    </Box>
  );
});

export default RuleChooser;
